<div class="px-3">
  <div class="breadcrumb mb-0">
    <app-ng7-dynamic-breadcrumb [bgColor]="breadcrumbConfig['bgColor']" [fontSize]="breadcrumbConfig['fontSize']"
      [fontColor]="breadcrumbConfig['fontColor']" [lastLinkColor]="breadcrumbConfig['lastLinkColor']"
      [symbol]="breadcrumbConfig['symbol']" class="sop-text-transform"></app-ng7-dynamic-breadcrumb>
  </div>
</div>
<div class="main-container">
  <router-outlet></router-outlet>
</div>